module.exports = __webpack_public_path__ + "static/media/alert_rieltor_gift_mob.a32e672b.png";